import styled, { css } from 'styled-components';
import Button from 'gatsby-theme-core/src/components/button/index';

export default styled(Button).attrs({ eventActionResult: 'next_step' })`
  ${({ $horizontal }) => $horizontal && css`
    && {
      margin-top: 0;
    }
  `}
  ${({ $standout }) => $standout && css`
    padding: 1.5rem 2rem;
  `}
`;
